import { ConfigurationService } from "../../services/ConfigurationService";
import { useApi } from "./useApi";
import { useConfiguration } from "./useConfiguration";

export const useConfigurationApi = () => {
    const { executeApiOperation } = useApi();
    const { appConfig } = useConfiguration();

    const configurationService = new ConfigurationService(appConfig.apiBaseUrl);

    const findAllCountries = async () => {
        return executeApiOperation(() => configurationService.getCountries());
    };

    return {
        findAllCountries,
    };
};
